export default __webpack_public_path__ + "static/media/logo.cffff06d.png";